import React, {Component} from 'react';
import {connect} from 'formik';
import isNumber from 'lodash/isNumber';
import SliderWidget from '../../widgets/SliderWidget';

class SliderField extends Component {
    constructor(props) {
        super(props);
        this.validate = this.validate.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.id !== prevProps.id) {
            this.props.formik.unregisterField(prevProps.id);
            this.props.formik.registerField(this.props.id, this);
        }
    }

    validate(value) {
        return this.props.validate(value);
    }

    handleChange(e) {
        const {formik, id} = this.props;
        formik.setFieldValue(id, e);
    }

    render() {
        const {min, max, step, origin, minLabel, maxLabel, marks} = this.props;
        const params = {
            origin: isNumber(origin) ? origin : min,
            min,
            max,
            minLabel,
            maxLabel,
            marks,
            step,
            dots: true,
        };

        return (
            <div className="form-group">
                <SliderWidget {...params} onChange={this.handleChange} />
            </div>
        );
    }
}

export default connect(SliderField);
